/* eslint-disable no-underscore-dangle */

const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate jobsWithReportsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const reportTypeIdentifiers = await evaluateSource(source.reportTypeIdentifiers, content, parentContentPath, transientContext, nativeFunctions);
  const ifContent = await evaluateSource(source.ifContent, content, parentContentPath, transientContext, nativeFunctions);
  const hasChildren = await evaluateSource(source.hasChildren, content, parentContentPath, transientContext, nativeFunctions);
  const reportID = content.id;
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'Report',
    properties: ['job/id', 'job/jobNumber'],
    equalsOneOf: {
      'reportType/identifier': reportTypeIdentifiers
    },
    doesNotEqual: {
      id: reportID
    },
    ifContent
  };
  const reports = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
  const jobs = {};
  reports.forEach(report => {
    jobs[report.job.id] = {
      title: report.job.jobNumber,
      _created: report.job.jobNumber
    };
    if (hasChildren !== undefined) {
      jobs[report.job.id].hasChildren = hasChildren;
    }
  });
  return jobs;
};
module.exports = {
  evaluate
};